// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StoreCarousel {
    width: 100%;
    padding: 0;
    overflow: hidden;
}

.StoreCarousel-limit-container {
    margin: 24px -8px;
}

.StoreCarousel-limit-container .slick-list {
    overflow: initial !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/StoresShowcase/components/StoreCarousel/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":[".StoreCarousel {\n    width: 100%;\n    padding: 0;\n    overflow: hidden;\n}\n\n.StoreCarousel-limit-container {\n    margin: 24px -8px;\n}\n\n.StoreCarousel-limit-container .slick-list {\n    overflow: initial !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
